var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"}},_vm._l((_vm.base64Tracking),function(base64,key){return _c('labelPDFSingle',{key:key,attrs:{"keyIndex":key,"order":_vm.order,"base64":base64}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }